import { MyProfileActions } from '../actions';
import { createReducer, on } from '@ngrx/store';
import { LegalEntitiesState } from '../my-profile-state';

export const initialState: LegalEntitiesState = {
    legalEntities: null
};

export const legalEntityReducer = createReducer(
    initialState,
    on(MyProfileActions.fetchLegalEntityListSuccess, (state, { legalEntities }) => {
        return {
            ...state,
            legalEntities: legalEntities
        };
    }),
);




